import { render, staticRenderFns } from "./TheSiteHeader.vue?vue&type=template&id=ed617d3e&"
import script from "./TheSiteHeader.vue?vue&type=script&lang=js&"
export * from "./TheSiteHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheSiteHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed617d3e')) {
      api.createRecord('ed617d3e', component.options)
    } else {
      api.reload('ed617d3e', component.options)
    }
    module.hot.accept("./TheSiteHeader.vue?vue&type=template&id=ed617d3e&", function () {
      api.rerender('ed617d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/layouts/partials/TheSiteHeader.vue"
export default component.exports